/**
 * Stripe Checkout redirect utility.
 *
 * For Stripe, the payment flow uses Stripe's hosted Checkout page.
 * After payment, the user is redirected back to the app via success/cancel URLs.
 */
export const redirectToStripeCheckout = (checkoutUrl: string): void => {
  window.location.href = checkoutUrl;
};

/**
 * Check if a response from the backend indicates Stripe as the payment provider.
 */
export const isStripeProvider = (response: { payment_provider?: string }): boolean => (
  response.payment_provider === 'stripe'
);
